import React from 'react';

function Header() {
  return (
    <header>
      <a href="#" className="logo">TARKOV HUB</a>
      <nav>
        <ul>
          <li><a href="#tracker" style={{ color: '#9d8b70' }}>Item Tracker</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
